import { Injectable } from '@angular/core';
import { Banner } from '../../shared/models/banner';
import { TransfersBanners } from '../../shared/models/domain/transfers-banners';
import { ClusterBanner } from '../../shared/models/domain/cluster-banner';
import { ResponseBanner } from 'src/app/shared/models/response-banner';

@Injectable({
  providedIn: 'root',
})
export class BannerService {

  MAX_SLOT_BANNERS_AVAILABLE = 3;

  constructor() {}

  public initializeBanners(responseBanner: ResponseBanner): TransfersBanners {
    const transfersBanners: TransfersBanners = {topBanner:null,clusterBanners:[],preItemBanner:null,postItemBanner:null,headBanner:null };
    if (responseBanner) {
      transfersBanners.topBanner = responseBanner.topBanner;
      transfersBanners.headBanner = responseBanner.headBanner;
      const banners: Banner[] = responseBanner.items;
      banners.forEach (banner => transfersBanners.clusterBanners.push( {banner, order: 0}));
      if (banners.length) { this.setClusterBannersOrder(transfersBanners.clusterBanners); }
    }
    return transfersBanners;
  }

  private setClusterBannersOrder(clusterBanners: ClusterBanner[]):void {
    // First banner goes into under first cluster
    if (clusterBanners[0]) {  clusterBanners[0].order = 0; }
    // second banner goes into under third cluster
    if (clusterBanners[1]) { clusterBanners[1].order = 2; }
    // TO-DO Agregar logica en caso de HH, filtros, etc con NGRX
    /*** Reglas del banner
    * Si es 1024 -> Tab Todas en 2º posicion (o 4º posicion si es HH)
    * Si es 320 -> Tab Shared en 2º posicion (o tab private en 3º posicion si es HH) */
  }

}

